import type { ComponentType } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

type RouterProps = {
  router: {
    location: ReturnType<typeof useLocation>;
    navigate: ReturnType<typeof useNavigate>;
    params: ReturnType<typeof useParams>;
  };
};

export const withRouter = <P extends RouterProps>(Component: ComponentType<P>) => {
  function ComponentWithRouterProp(props: Omit<P, keyof RouterProps>) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return (
      <Component
        {...(props as P)}
        router={{ location, navigate, params }}
      />
    );
  }

  return ComponentWithRouterProp;
};
